export default [

  {
    path: '/dashboard/',
    name: 'dashboard',
    component: () => import('@/layouts/LayoutDashboard.vue'),
    redirect: '/dashboard/main'
  },
  {
    path: '/',
    name: 'base',
    component: () => import('@/layouts/LayoutPublic.vue'),
    redirect: 'login'
  }
]
